import styled from 'styled-components'

export const TitleMedium = styled.div`
  font-size: 2.25rem;
  font-weight: 900;
  color: var(--shape);
`
